export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/fileGenerator.worker.24152c97.js");
}
